import { UpdateStateIndicator } from "@digital-services/ui";

export const EmailInputAdornment = ({ isLoading }) => {
  return isLoading ? (
    <UpdateStateIndicator
      isUpdating={isLoading}
      isUpdated={!isLoading}
      setIsUpdated={() => {}}
    />
  ) : null;
};
